export default {
 TITLE:'Now for a few more details…',
 SUBTITLE:'Add {{type}}'
}